import { createRouter, createWebHashHistory } from "vue-router";
import chooseDirectionScreen from "./pages/ChooseDirectionScreen/ChooseDirectionScreen.vue"
import professionsScreen from "./pages/ProfessionsScreen/ProfessionsScreen.vue"
import specialtiesScreen from "./pages/SpecialtiesScreen/SpecialtiesScreen.vue"
import professionalismScreen from "./pages/ProfessionalismScreen/ProfessionalismScreen.vue"
import collegesListSpecialityScreen from "./pages/CollegesListScreen/CollegesListSpecialityScreen.vue"
import collegesListProfessionScreen from "./pages/CollegesListScreen/CollegesListProfessionScreen.vue"
import collegesListProfessionalismScreen from "./pages/CollegesListScreen/CollegesListProfessionalismScreen.vue"
import educationScreen from "./pages/EducationScreen/EducationScreen.vue"
import notFoundScreen from "./components/NotFoundScreen.vue"

export default createRouter({
    history: createWebHashHistory(),
    routes: [
        { path: '/', name: 'directions', component: chooseDirectionScreen },
        { path: '/directions/:id/professions/', name: 'professions', component: professionsScreen },
        { path: '/directions/:id/specialties/', name: 'specialties', component:  specialtiesScreen},
        { path: '/directions/:id/professionalism/', name: 'professionalism', component:  professionalismScreen},
        { path: '/directions/specialties/:id/colleges_list_screen/', name: 'collegeslistSpecialties', component:  collegesListSpecialityScreen},
        { path: '/directions/profession/:id/colleges_list_screen/', name: 'collegeslistProfession', component:  collegesListProfessionScreen},
        { path: '/directions/professionalism/:id/colleges_list_screen/', name: 'collegeslistProfessionalism', component:  collegesListProfessionalismScreen},
        { path: '/education/:id', name: 'education', component: educationScreen },
        { path: '/:pathMatch(.*)*', name: 'not-found', component: notFoundScreen },
    ],
})